module.exports = __webpack_public_path__ + "wood.svg?b901f861fa39db11f8e8f3cf643267a6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wood.svg
// module id = 90
// module chunks = 0